<!-- Filtros para tabla de empleados -->
<template>
  <div>
    <v-container>
      <v-row justify="space-around">
        <v-col cols="12" lg="12">
          <v-form :v-model="true">
            <v-col cols="12" class="ma-0 pa-3">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="dFilters.complainant"
                    :label="$t('compDetails.name')" 
                    :items="dComplainants" 
                    item-value="name" 
                    item-text="name"           
                    item-color="datPrimary" 
                    color="datPrimary"
                    hide-details  
                    clearable
                    class="mt-0"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="dFilters.status"
                    :label="$t('compDetails.status')" 
                    :items="dStatusList"  
                    item-value="status" 
                    item-text="description"          
                    item-color="datPrimary" 
                    color="datPrimary"
                    hide-details  
                    clearable
                    class="mt-0"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="dFilters.typeId"
                    :label="$t('compDetails.typeId')" 
                    :items="dComplaintTypes" 
                    item-value="typeId" 
                    item-text="typeDescription"            
                    item-color="datPrimary" 
                    color="datPrimary"
                    hide-details  
                    clearable
                    class="mt-0"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <datDatePicker v-model="dFilters.iniDate" appendIcon= 'mdi-calendar' :label="$t('labels.iniDate')" />
                </v-col>
                <v-col cols="12" md="6">
                  <datDatePicker v-model="dFilters.endDate" appendIcon= 'mdi-calendar' :label="$t('labels.endDate')" />
                </v-col>
              </v-row>
            </v-col>
          </v-form>
        </v-col>

        <v-col cols="auto mb-4">
          <v-row justify="end">
            <v-btn depressed class="datPrimaryBtnOut ma-2" @click="fClose()">{{$t("datBtn.close")}}</v-btn>
            <v-btn depressed class="datPrimaryBtn ma-2" @click="fSave()">{{$t("datBtn.save")}}</v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
//
import mxCanalDenuncias from "@/mixins/mxCanalDenuncias.vue"
import ServiceEcomplaints from "@/services/srv-eComplaints"

// Componentes 
import datDatePicker from '@/components/datDatePicker'

export default {
  mixins: [mxCanalDenuncias],

  components: {
    datDatePicker
  },  

  props: {
    pFilters: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      dComplainants: [],
      dStatusList: [
        {status: 'NUEVA', description: this.$t('labels.new')},
        {status: 'TRAMITE', description: this.$t('labels.pending')},
        {status: 'RESUELTA', description: this.$t('labels.solved')},
        {status: 'RECHAZADA', description: this.$t('labels.rejected')},
        {status: 'ACEPTADA', description: this.$t('labels.accepted')},
        {status: 'REABIERTA', description: this.$t('labels.reopen')}
      ],
      dComplaintTypes: [],
      dFilters:{
        typeId: null,
        complainant: null,
        status: null,
        iniDate: undefined,
        endDate: undefined
      }
    }
  },
  mounted(){
    if(this.pFilters){
      this.dFilters = this.pFilters
    }
    this.fGetCompTypesList()
    this.fGetUsersList()
  },

  methods: {
    fClose() {
      this.$emit("close")
    },

    fSave() {
      this.$emit("close", this.dFilters)
    },

    // Obtiene la lista con todos los tipos de denuncias
    fGetCompTypesList() {
      ServiceEcomplaints.getComplaintTypes({}).then((response) => {
        this.dComplaintTypes = response.dataRes
      }).catch((error) => {
        this.fSnackbarError(error, this.pShowSnackbar)
      })
    },

    // Obtiene la lista con todos los tipos de denuncias
    fGetUsersList() {
      ServiceEcomplaints.getUsersList({}).then((response) => {
        this.dComplainants = response.dataRes
      }).catch((error) => {
        this.fSnackbarError(error, this.pShowSnackbar)
      })
    }
  },

  watch:{
    pFilters(){
      if(this.pFilters){
        this.dFilters = this.pFilters
      }
    }
  }
}
</script>